export default __webpack_public_path__ + "static/media/356.154c8c52.png";